import { updateSubscriptionStatus } from "stores/slice/bogus/license/const";

const licenseConfig = {
  // Dashboard
  "/orgs/:orgId/license/dashboard.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/license/dashboard",
    mockSelector: "license.dashboard",
  },
  "/ents/:entId/orgs/:orgId/license/dashboard.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/ents/:entId/orgs/:orgId/license/dashboard",
    mockSelector: "license.dashboard",
  },

  // Service Status
  "/orgs/:orgId/license/service/status.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/license/service/status",
    mockSelector: "license.serviceStatus",
  },
  "/ents/:entId/orgs/:orgId/license/service/status.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/ents/:entId/orgs/:orgId/license/service/status",
    mockSelector: "license.serviceStatus",
  },
  "/orgs/:orgId/sites/:siteId/license/service/status.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/sites/:siteId/license/service/status",
    mockSelector: "license.siteServiceStatus",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/license/service/status.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/license/service/status",
    mockSelector: "license.siteServiceStatus",
  },

  // History
  "/orgs/:orgId/license/history.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/license/history",
    mockSelector: "license.history",
  },
  "/ents/:entId/orgs/:orgId/license/history.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/ents/:entId/orgs/:orgId/license/history",
    mockSelector: "license.history",
  },

  // Import
  "/orgs/:orgId/license/add.create": {
    protocol: "ws",
    method: "create",
    restful: true,
    resource: "/orgs/:orgId/license/add",
    mockSelector: "license.import",
  },
  "/ents/:entId/orgs/:orgId/license/add.create": {
    protocol: "ws",
    method: "create",
    restful: true,
    resource: "/ents/:entId/orgs/:orgId/license/add",
    mockSelector: "license.import",
  },

  // Subscriptions
  "/orgs/:orgId/license/subscriptions.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/license/service/status",
    mockSelector: "license.serviceStatus",
  },
  "/ents/:entId/orgs/:orgId/license/subscriptions.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/ents/:entId/orgs/:orgId/license/service/status",
    mockSelector: "license.serviceStatus",
  },
  "/orgs/:orgId/license/subscriptions.update": {
    protocol: "ws",
    method: "update",
    restful: true,
    resource: "/orgs/:orgId/license/service/subscribe",
    action: updateSubscriptionStatus,
    mockSelector: "license.subscribeResult",
    },
    "/ents/:entId/orgs/:orgId/license/subscriptions.update": {
    protocol: "ws",
    method: "update",
    restful: true,
    resource: "/orgs/:orgId/license/service/subscribe",
    action: updateSubscriptionStatus,
    mockSelector: "license.subscribeResult",
    },

  // Base Rates
  "/orgs/:orgId/license/base-rates.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/license/base-rates",
    mockSelector: "license.baseRates",
  },
  "/ents/:entId/orgs/:orgId/license/base-rates.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/ents/:entId/orgs/:orgId/license/base-rates",
    mockSelector: "license.baseRates",
  },

  // Device Counts
  "/orgs/:orgId/license/device-counts.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/license/device-counts",
    mockSelector: "license.deviceCounts",
  },
  "/ents/:entId/orgs/:orgId/license/device-counts.read": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/ents/:entId/orgs/:orgId/license/device-counts",
    mockSelector: "license.deviceCounts",
  },

  // Service PreConfirm
  "/orgs/:orgId/license/service/subscribe/preConfirm": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/orgs/:orgId/license/service/subscribe/preConfirm",
    mockSelector: "license.licensePreConfirm",
  },
  "/ents/:entId/orgs/:orgId/license/service/subscribe/preConfirm": {
    protocol: "ws",
    method: "read",
    restful: true,
    resource: "/ents/:entId/orgs/:orgId/license/service/subscribe/preConfirm",
    mockSelector: "license.licensePreConfirm",
  },
};

export default licenseConfig;
